import PlantSubServicePage from "@/components/PlantSubServicePage";

const RELATED = [
  { to: "/piping", label: "Piping" },
  { to: "/civil-structural", label: "Civil & Structural" },
  { to: "/electrical-instrumentation", label: "Electrical & Instrumentation" },
  { to: "/materials", label: "Material (MTC)" },
];

export default function Mechanical() {
  return (
    <PlantSubServicePage
      slug="mechanical"
      title="Mechanical"
      lead="Static and rotating equipment design and engineering — tailored mechanical solutions for efficiency, safety and reliability."
      intro={[
        "ZeroLabs Digitals' Mechanical team brings extensive expertise in the design and engineering of Static and Rotating equipment across a wide range of industries — Oil & Gas, Refining, Petrochemicals, Chemicals, Pharmaceuticals, Power, Water Treatment, Paper & Pulp, Steel and more.",
        "We deliver high-quality, tailored mechanical solutions that ensure efficiency, safety and reliability for every project.",
        "Our team is proficient in leading software tools for mechanical design — Autodesk and PV Elite — enabling us to provide precision-driven solutions that meet your specific needs.",
      ]}
      industries={["Oil & Gas", "Refining", "Petrochemicals", "Chemicals", "Pharmaceuticals", "Power", "Water Treatment", "Paper & Pulp", "Steel"]}
      tools={["Autodesk Inventor", "PV Elite", "Compress", "ANSYS"]}
      heroImage="https://www.thantrick.com/wp-content/uploads/2025/04/Mechanical-1024x585.webp"
      gallery={[
        "https://www.thantrick.com/wp-content/uploads/2025/04/Mechanical-300x171.webp",
        "https://www.thantrick.com/wp-content/uploads/2025/04/civilStructural-300x193.jpg",
      ]}
      thantrickUrl="https://thantrick.org/mechanical-2/"
      related={RELATED}
    />
  );
}
